import { GameCategoryIds } from '@/views/game/consts/categorys'

/** 取得默认背景图片(单例类) */
export class CardDefaultBgImg {
  // 单例模式
  private static instance: CardDefaultBgImg
  /** 获得实例 */
  private static getInstance() {
    if (!CardDefaultBgImg.instance) {
      CardDefaultBgImg.instance = new CardDefaultBgImg()
    }
    return CardDefaultBgImg.instance
  }
  private constructor() {
    this.bgPrePath = '/lobby_asset/{layout}-{bg}-{skin}/web/home'
    this.noBgPrePath = '/lobby_asset/{layout}-{bg}-common/web/home'
    this.bgImgMapper = {
      [GameCategoryIds.Fish]: '/img_bg1_by.png',
      [GameCategoryIds.Lottery]: '/img_bg1_cp.png',
      [GameCategoryIds.Electronic]: '/img_bg1_dz.png',
      [GameCategoryIds.BlockChain]: '/img_bg1_qp-zr.png',
      [GameCategoryIds.Chess]: '/img_bg1_qp-zr.png',
      [GameCategoryIds.Real]: '/img_bg1_qp-zr.png',
      [GameCategoryIds.Sports]: '/img_bg1_by.png',
      [GameCategoryIds.Gaming]: '/img_bg1_by.png',
      [GameCategoryIds.Cockfighting]: '/img_bg1_qp-zr.png'
    } as Record<GameCategoryIds, string>
  }

  /** 背景图的mapper映射 */
  private bgImgMapper: Record<GameCategoryIds, string>
  /** 有底背景图路径 */
  private bgPrePath: string
  /** 无底背景图路径 */
  private noBgPrePath: string
  /** 取得经典的横向卡片背景图 */
  public static getBgImg(categroyId: GameCategoryIds, background = true) {
    try {
      const cardBgImg = this.getInstance()
      const path = background ? cardBgImg.bgPrePath : cardBgImg.noBgPrePath
      return path + cardBgImg.bgImgMapper[categroyId]
    } catch (error) {
      return ''
    }
  }
}
